import React, {Component} from 'react'
import FilterStatus from './filters/FilterStatus'
import {Select} from "antd"
import {PRINT_QR} from "../helper/batchStatus.json"

class BatchFilters extends Component {
    getOptionOverTime = (start, end) => {
        const Options = [
            {
                name: 'Tất cả',
                value: '',
            },
        ]
        for (let i = start; i <= end; i++) {
            if(i !== 0) {
                const Option = {
                    name: i,
                    value: i,
                }
                if(i === -1) {
                    Options.push({name: -1.5,value: -1.5,})
                }
                Options.push(Option)
            }
        }
        return Options
    }

    _handleChangeOverTime = (value) => {
        const {onChangeStatus} = this.props
        onChangeStatus('item_overtime', value)
    }

    render() {
        const {onChangeStatus} = this.props
        const {Option} = Select
        const OverTime = this.getOptionOverTime(-6,6)

        return (
            <div className='FilterOptions d-flex flex-wrap'>
                <FilterStatus {...this.props} />
                <div className='FilterStatus mr-4'>
                    <label className="mr-2 font-weight-bold">Quá hạn:</label>
                    <Select defaultValue={''} name="status" style={{ width: 160 }}
                        onChange={this._handleChangeOverTime}>
                        {
                            OverTime.map((item, index) =>
                                <Option key={index} value={item.value}>
                                    {item.name}
                                </Option>
                            )
                        }
                    </Select>
                </div>
                <div className='FilterStatus mr-4'>
                    <label className="mr-2 font-weight-bold">In QR:</label>
                    <Select defaultValue={''} name="printed_qr" style={{ width: 160 }}
                        onChange={value => onChangeStatus('printed_qr', value)}>
                        {
                            PRINT_QR.map((item, index) =>
                                <Option key={index} value={item.value}>
                                    {item.name}
                                </Option>
                            )
                        }
                    </Select>
                </div>
            </div>
        )
    }
}

export default BatchFilters